/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Decklists_Help_FinalistsInputs */



/**
* | output |
* | --- |
* | "Once the event finishes, the winner's and finalists' decklists become public." |
*
* @param {Tfield_Decklists_Help_FinalistsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_decklists_help_finalists = /** @type {((inputs?: Tfield_Decklists_Help_FinalistsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Decklists_Help_FinalistsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une fois l'événement terminé, les decklists du vainqueur et des finalistes deviennent publiques.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Una vez finalizado el evento, las decklists del ganador y los finalistas se hacen públicas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Assim que o evento terminar, as decklists do vencedor e dos finalistas se tornam públicas.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Al termine dell'evento, le decklist del vincitore e dei finalisti diventano pubbliche.")
	return /** @type {LocalizedString} */ ("Once the event finishes, the winner's and finalists' decklists become public.")
});